import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./PortalCandidato.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import { useNavigate } from "react-router-dom";
import CriarVaga from "./CriarVaga/CriarVaga";
import EditaVaga from "./EditarVaga/EditaVaga";
import { FaCopy, FaCheck } from "react-icons/fa";

export default function PortalCandidato() {


  const [copiadoId, setCopiadoId] =
    useState(null);

  const navigate = useNavigate();

  const [admin, setAdmin] = useState(false);
  const [modalCriarVaga, setModalCriarVaga] = useState(false);

  const [modalEditarVaga, setModalEditarVaga] =
    useState(false);

const [vagaSelecionada, setVagaSelecionada] =
    useState(null);

  const [vagas, setVagas] = useState([]);
  const [loading, setLoading] = useState(true);

  const [busca, setBusca] = useState("");

  const [cidade, setCidade] = useState("");

  const [paginaAtual, setPaginaAtual] =
    useState(1);

  const vagasPorPagina = 8;


  function editarVaga(vaga) {

    setVagaSelecionada(vaga);

    setModalEditarVaga(true);

}


  async function carregarVagas() {

  try {

    setLoading(true);

    const response = await axios.get(
      "https://app.eliandroalimentos.com.br/api/vagas/listar"
    );

    const params = new URLSearchParams(window.location.search);

    const token = params.get("token");

    let ehAdmin = false;

    if (token) {

      try {

        const dados = JSON.parse(atob(token));

        ehAdmin = !!dados.id_usuario;

      } catch {}

    }

    setAdmin(ehAdmin);

    if (ehAdmin) {

      setVagas(response.data);

    } else {

      setVagas(
        response.data.filter(
          vaga => Number(vaga.ativo) === 1
        )
      );

    }

  } finally {

    setLoading(false);

  }

}

  useEffect(() => {
    carregarVagas();
  }, []);


  const cidades = useMemo(() => {
    return [
      ...new Set(
        vagas
          .map((v) => v.cidade)
          .filter(Boolean)
          .sort()
      ),
    ];
  }, [vagas]);

  const vagasFiltradas = useMemo(() => {
    return vagas.filter((vaga) => {
      const pesquisa =
        busca.toLowerCase();

      const encontrouTexto =
        vaga.vaga
          .toLowerCase()
          .includes(pesquisa) ||
        vaga.cidade
          .toLowerCase()
          .includes(pesquisa);

      const encontrouCidade =
        cidade === "" ||
        vaga.cidade === cidade;

      return (
        encontrouTexto &&
        encontrouCidade
      );
    });
  }, [vagas, busca, cidade]);

  const totalPaginas = Math.ceil(
    vagasFiltradas.length /
    vagasPorPagina
  );

  const vagasPagina =
    vagasFiltradas.slice(
      (paginaAtual - 1) *
      vagasPorPagina,
      paginaAtual *
      vagasPorPagina
    );

  async function excluirVaga(id) {

    const confirmar = window.confirm(
      "Deseja realmente excluir esta vaga?"
    );

    if (!confirmar) {
      return;
    }

    try {

      await axios.delete(
        `https://app.eliandroalimentos.com.br/api/vagas/deletarvaga/${id}`
      );

      await carregarVagas();

    } catch (error) {

      console.error(
        "Erro ao excluir vaga:",
        error
      );

      alert(
        error.response?.data?.error ??
        "Erro ao excluir vaga."
      );

    }

  }

  async function alterarStatusVaga(id, ativoAtual) {

    try {

      await axios.put(
        "https://app.eliandroalimentos.com.br/api/vagas/editarativo",
        {
          id,
          ativo: ativoAtual ? 0 : 1,
        }
      );

      await carregarVagas();

    } catch (error) {

      console.error(
        "Erro ao alterar status da vaga:",
        error
      );

      alert(
        error.response?.data?.error ??
        "Erro ao alterar status da vaga."
      );

    }

  }

  async function copiarLink(id) {

    const url =
      `https://app.eliandroalimentos.com.br/vaga/${id}`;

    try {

      if (navigator.clipboard && window.isSecureContext) {

        await navigator.clipboard.writeText(url);

      } else {

        const textarea =
          document.createElement("textarea");

        textarea.value = url;

        textarea.style.position = "fixed";
        textarea.style.left = "-999999px";

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();

        document.execCommand("copy");

        textarea.remove();

      }

      setCopiadoId(id);

      setTimeout(() => {
        setCopiadoId(null);
      }, 2000);

    } catch (error) {

      console.error(
        "Erro ao copiar link:",
        error
      );

      alert(
        "Não foi possível copiar o link."
      );

    }

  }

  return (
    <div className="portal-candidato">

      <header className="portal-header">
        <div className="header-left">
          <img
            src={Imagens.Logo}
            alt="Eliandro Alimentos"
            className="logo"
          />

          <span className="divider" />

          <h1>
            Portal do Candidato
          </h1>
        </div>
      </header>



      <CriarVaga
        aberto={modalCriarVaga}
        onClose={() => setModalCriarVaga(false)}
        atualizarVagas={carregarVagas}
      />

      <EditaVaga
    aberto={modalEditarVaga}
    onClose={() =>
        setModalEditarVaga(false)
    }
    atualizarVagas={carregarVagas}
    vaga={vagaSelecionada}
/>

      <div className="portal-content">


        <div className="titulo-vagas">

          <h3>LISTA DE VAGAS</h3>

          {admin && (
            <button
              className="btn-criar-vaga"
              onClick={() => setModalCriarVaga(true)}
            >
              + Criar Vaga
            </button>
          )}

        </div>
        <div className="filters">

          <input
            type="text"
            placeholder="Pesquisar vaga ou cidade..."
            value={busca}
            onChange={(e) => {
              setBusca(
                e.target.value
              );

              setPaginaAtual(1);
            }}
          />

          <select
            value={cidade}
            onChange={(e) => {
              setCidade(
                e.target.value
              );

              setPaginaAtual(1);
            }}
          >
            <option value="">
              Todas as cidades
            </option>

            {cidades.map(
              (cidadeAtual) => (
                <option
                  key={cidadeAtual}
                  value={cidadeAtual}
                >
                  {cidadeAtual}
                </option>
              )
            )}
          </select>

        </div>

        {loading ? (

          <p>
            Carregando vagas...
          </p>

        ) : (

          <div className="vagas-lista">

            {vagasPagina.length ===
              0 ? (

              <p>
                Nenhuma vaga
                encontrada.
              </p>

            ) : (

              vagasPagina.map(
                (vaga) => (
                  <div
                    key={vaga.id}
                    className="vaga-item"
                  >

                    <div>

                      <strong>
                        {vaga.vaga}
                      </strong>

                      <span>
                        {vaga.cidade}, RS
                      </span>

                    </div>

                    <div className="acoes-vaga">

                      <button
                        className="btn-copiar-vaga"
                        onClick={() =>
                          copiarLink(vaga.id)
                        }
                      >
                        {copiadoId === vaga.id ? (
                          <FaCheck />
                        ) : (
                          <FaCopy />
                        )}
                      </button>



                      <button
                        onClick={() =>
                          navigate(`/vaga/${vaga.id}`)
                        }
                      >
                        Ver detalhes
                      </button>

                      {admin && (

                        <button
                          className={
                            Number(vaga.ativo) === 1
                              ? "btn-status-vaga ativo"
                              : "btn-status-vaga inativo"
                          }
                          onClick={() =>
                            alterarStatusVaga(
                              vaga.id,
                              Number(vaga.ativo)
                            )
                          }
                        >
                          {Number(vaga.ativo) === 1
                            ? "Ativa"
                            : "Desativada"}
                        </button>

                      )}

                      {admin && (

    <button
        className="btn-editar-vaga"
        onClick={() =>
            editarVaga(vaga)
        }
    >
        Editar
    </button>

)}

                      {admin && (

                        <button
                          className="btn-excluir-vaga"
                          onClick={() =>
                            excluirVaga(vaga.id)
                          }
                        >
                          ✕
                        </button>

                      )}

                    </div>

                  </div>
                )
              )

            )}

          </div>

        )}

        {totalPaginas > 1 && (
          <div className="paginacao">
            <div className="paginas">

              <button
                disabled={paginaAtual === 1}
                onClick={() =>
                  setPaginaAtual(1)
                }
              >
                {"<<"}
              </button>

              <button
                disabled={paginaAtual === 1}
                onClick={() =>
                  setPaginaAtual(
                    paginaAtual - 1
                  )
                }
              >
                {"<"}
              </button>

              {Array.from(
                {
                  length: totalPaginas,
                },
                (_, index) => (
                  <button
                    key={index}
                    className={
                      paginaAtual ===
                        index + 1
                        ? "ativo"
                        : ""
                    }
                    onClick={() =>
                      setPaginaAtual(
                        index + 1
                      )
                    }
                  >
                    {index + 1}
                  </button>
                )
              )}

              <button
                disabled={
                  paginaAtual ===
                  totalPaginas
                }
                onClick={() =>
                  setPaginaAtual(
                    paginaAtual + 1
                  )
                }
              >
                {">"}
              </button>

              <button
                disabled={
                  paginaAtual ===
                  totalPaginas
                }
                onClick={() =>
                  setPaginaAtual(
                    totalPaginas
                  )
                }
              >
                {">>"}
              </button>

            </div>

            <span className="total">
              {vagasFiltradas.length}{" "}
              {vagasFiltradas.length ===
                1
                ? "vaga encontrada"
                : "vagas encontradas"}
            </span>
          </div>
        )}

      </div>

      <footer className="portal-footer">

      </footer>

    </div>
  );
}